// lowercase
export enum FieldClassEnum {
  Dimension = 'dimension',
  Time = 'time',
  Measure = 'measure',
  Calculation = 'calculation',
  Filter = 'filter',
  // for nodeClass:
  Join = 'join',
  Info = 'info'
}
